define('model/selector',[], function() {
    'use strict';
    function isArray(a) {
        return a !== undefined && a.constructor.toString().indexOf('Array') > -1;
    }

    function filterArray(result, fields) {
        var i;
        for (i = 0; i < result.length; i += 1) {
            filter(result[i], fields);
        }
    }

    function filterObject(result, fields) {
        var key;
        var filterPrepared = '*' + fields.trim().split(/\s*,\s*/).join('*') + '*';
        for (key in result) {
            if (result.hasOwnProperty(key) && filterPrepared.indexOf('*' + key + '*') < 0) {
                delete result[key];
            }
        }
    }

    function filter(result, fields) {
        if (!fields) {
            return result;
        }
        if (isArray(result)) {
            filterArray(result, fields);
        } else {
            filterObject(result, fields);
        }
        return result;
    }

    function handleArray(array, key) {
        var j;
        var result = [];
        for (j = 0; j < array.length; j += 1) {
            if (array[j][key]) {
                result.push(array[j][key]);
            }
        }
        return result;
    }

    return function(json, path, fields) {
        var i;
        var result = json;
        var pathElements = path.trim().split('.');
        for (i = 0; i < pathElements.length; i += 1) {
            if (!result) {
                return null;
            }
            if (isArray(result)) {
                result = handleArray(result, pathElements[i]);
            } else {
                result = result[pathElements[i]];
            }
        }
        return filter(result, fields);
    };
});

